import { createReducer, on } from "@ngrx/store";
import { GeneralResume } from "src/app/models/general-resumen";
import { loadData, loadDataSuccess, loadDataFailure, loadPolicyHolderSuccess, setData } from './general.actions';
import { state } from "@angular/animations";
import { merge } from 'rxjs';

export interface GeneralState<T = any> {
    data: { [key: string]: T };
    error: Error | null;
}

export const initialState: GeneralState = {
    data: {},
    error: null
};

export const generalReducer = createReducer(initialState,
    on(loadData, state => ({ ...state })),
    on(loadDataSuccess, (state, { data }) => {
        
        return {
            ...state,
            data: {
                ...data,
            }
        };
    }),
    on(loadDataFailure, (state, { error }) => {
        console.error('Reducer: loadDataFailure', error);
        return {
            ...state,
            error
        };
    }),
    on(loadPolicyHolderSuccess, (state, { PolicyHolder }) => {
        console.log('Reducer: loadPolicyHolderSuccess', PolicyHolder);
        return {
            ...state,
            data: {
                ...state.data,
                PolicyHolder
            }
        };
    }),

    on(setData, (state, { key, value, merge }) => ({
        ...state,
        data: {
            ...state.data,
            [key]: merge ? deepMerge(state.data[key] || {}, value) : value
        }
    }))
);

function deepMerge(target: any, source: any): any {
    // Si alguno es null o undefined, retornar source
    if (target == null || source == null) {
        return source || target;
    }

    // Si alguno no es un objeto, retornar source
    if (typeof target !== 'object' || typeof source !== 'object') {
        return source;
    }

    // Si target está vacío, retornar source
    if (Object.keys(target).length === 0) {
        return source;
    }

    const targetCopy = { ...target }; // Create a shallow copy of the target object
    return Object.keys(source).reduce((acc, key) => {
        acc[key] = key in targetCopy ? deepMerge(targetCopy[key], source[key]) : source[key];
        return acc;
    }, targetCopy);
}
